import { DefaultTheme, FlattenSimpleInterpolation } from 'styled-components'

import critical from './critical'
import criticalTertiary from './criticalTertiary'
import defaultButtonTemplate from './default'
import icon from './icon'
import info from './info'
import primary from './primary'
import secondary from './secondary'
import tertiary from './tertiary'
import transparent from './transparent'
import transparentCritical from './transparentCritical'
import transparentDark from './transparentDark'
import transparentLight from './transparentLight'
import transparentPrimary from './transparentPrimary'
import transparentOutlined from './transparentOutlined'
import warning from './warning'
import warningOutlined from './warningOutlined'
import whatsapp from './whatsapp'

/**
 * Templates
 */

export type ButtonTemplatesProps = {
  theme: DefaultTheme
  isSelected?: boolean
}

type IButtonTemplates = {
  [key in ButtonTemplates]: (
    props: ButtonTemplatesProps
  ) => FlattenSimpleInterpolation
}

export const buttonTemplates: IButtonTemplates = {
  primary: () => primary(),
  secondary: () => secondary(),
  tertiary: () => tertiary(),
  critical: () => critical(),
  criticalTertiary: () => criticalTertiary(),

  transparent: () => transparent(),
  transparentPrimary: () => transparentPrimary(),
  transparentCritical: () => transparentCritical(),
  transparentDark: () => transparentDark(),
  transparentLight: () => transparentLight(),
  transparentOutlined: () => transparentOutlined(),

  icon: props => icon(props),

  info: props => info(props),

  warning: props => warning(props),
  warningOutlined: props => warningOutlined(props),
  whatsapp: props => whatsapp(props)
}

/**
 * Default styles
 */

export type ContainerDefaultProps = ContainerProps &
  Pick<ButtonCoreProps, 'size'>

export type ButtonDefaultTemplateProps = {
  props: ContainerDefaultProps
} & ButtonTemplatesProps

type ButtonDefaultStyles = (
  props: ButtonDefaultTemplateProps
) => FlattenSimpleInterpolation

export const buttonDefaultStyles: ButtonDefaultStyles = props =>
  defaultButtonTemplate(props)
